import React from 'react';

import { ConfigProvider } from 'antd';

import { useThemeContext } from 'global/ThemeContext/ThemeContext';

const AntProvider = ({ children }: { children: React.ReactNode }) => {
  const theme = useThemeContext();

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            activeBorderColor: theme.primary,
            colorPrimary: theme.primary,
            colorPrimaryHover: theme.primary,
            borderRadius: 8,
            borderRadiusLG: 4,
            borderRadiusSM: 6,
          },
          Select: {
            borderRadius: 8,
            borderRadiusLG: 4,
            borderRadiusSM: 6,
            optionSelectedBg: theme.primary,
            optionActiveBg: theme.primary,
          },
          Menu: {
            itemHoverBg: theme.background.secondary,
            darkItemHoverColor: theme.text.primary,
            darkItemSelectedColor: theme.primary,
          },
          Tabs: {
            inkBarColor: theme.primary,
            itemSelectedColor: theme.primary,
            itemColor: theme.text.primary,
            colorBorderSecondary: theme.background.secondary,
            fontSize: 12,
            lineWidth: 2,
          },
          Modal: {
            titleColor: theme.text.secondary,
            headerBg: theme.background.primary,
            footerBg: theme.background.secondary,
            contentBg: theme.background.secondary,
            boxShadow: theme.primary,
            colorIcon: theme.primary,
            colorIconHover: theme.primary,
          },
          Switch: {
            colorPrimary: theme.primary,
            colorPrimaryHover: theme.primary,
            handleBg: theme.background.primary,
          },
          DatePicker: {
            activeBorderColor: theme.primary,
            hoverBorderColor: theme.primary,
            activeBg: theme.background.secondary,
            hoverBg: theme.background.secondary,
            colorBgContainer: theme.background.secondary,
            colorTextPlaceholder: theme.text.secondary,
            colorText: theme.primary,
            colorPrimary: theme.primary,
            colorPrimaryBorder: theme.primary,
            colorBorder: theme.text.primary,
            colorBgElevated: theme.background.secondary,
            controlItemBgActive: theme.primary,
            cellRangeBorderColor: theme.primary,
            cellHoverWithRangeBg: theme.primary,
            cellActiveWithRangeBg: theme.primary,
            colorTextHeading: theme.primary,
            colorIcon: theme.primary,
            colorIconHover: theme.primary,
            colorTextTertiary: theme.text.secondary,
            colorTextDisabled: theme.text.secondary,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default AntProvider;
